"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
const components_common_notifications_1 = require("@hotelplan/components.common.notifications");
const TravelersInputs_1 = require("./TravelersInputs");
const TravelRooms_model_1 = __importDefault(require("./TravelRooms.model"));
const TravelRooms_utils_1 = require("./TravelRooms.utils");
const TravelRoomsInfoNotification_1 = __importDefault(require("./TravelRoomsInfoNotification"));
const TravelRooms = ({ value, configuration, saveTravelRooms, closeTravelRooms, isManualDistribution, }) => {
    var _a;
    const [t] = (0, next_i18next_1.useTranslation)('search');
    const { state, changeAdultsCount, changeChildrenCount, changeCountOfRooms, changeDOB, } = (0, TravelRooms_model_1.default)(value, {
        isManualDistribution,
        isSearchForFourRoomsEnabled: configuration.isSearchForFourRoomsEnabled,
    });
    const { adults, maxAdultsCount, maxChildrenCount, minAdultsCount, minChildrenCount, childrenDobs, rooms, maxRoomsCount, minRoomsCount, } = state;
    const travellersCount = state.adults + state.childrenDobs.length;
    const childrenDOBAreValid = (0, TravelRooms_utils_1.validateChildren)(childrenDobs);
    const roomsLabel = configuration.infoNotification.enable ? (react_1.default.createElement("div", { className: "rooms-label-block" },
        react_1.default.createElement("span", null, t('rooms.rooms.label')),
        react_1.default.createElement(TravelRoomsInfoNotification_1.default, { text: configuration.infoNotification.notificationText }))) : (t('rooms.rooms.label'));
    const travelersInputsProps = {
        configuration,
        changeAdultsCount,
        changeChildrenCount,
        changeDOB,
        adults,
        maxAdultsCount,
        maxChildrenCount,
        minAdultsCount,
        minChildrenCount,
        childrenDobs,
        childrenDOBAreValid,
        travellersCount,
        rooms,
        maxRoomsCount,
        minRoomsCount,
        changeCountOfRooms,
        roomsLabel,
    };
    const containerProps = {
        configuration,
        state,
        changeCountOfRooms,
        closeTravelRooms,
        saveTravelRooms,
        roomsLabel,
    };
    (0, use_deep_compare_effect_1.default)(() => {
        if (configuration.hasApplyBtn && !configuration.forceSaveOnEveryChange)
            return;
        if (saveTravelRooms)
            saveTravelRooms(state);
    }, [state]);
    const maxTravellers = configuration.isSearchForFourRoomsEnabled
        ? TravelRooms_utils_1.MAX_TRAVELLERS_FOR_FOUR_ROOMS
        : TravelRooms_utils_1.MAX_TRAVELLERS_DEFAULT;
    return (react_1.default.createElement(TravelersInputs_1.TravelRoomsContainer, Object.assign({}, containerProps),
        react_1.default.createElement(TravelersInputsSection, { isManual: isManualDistribution, travelRooms: (_a = state.travellersDistribution) === null || _a === void 0 ? void 0 : _a.rooms, inputsProps: travelersInputsProps }),
        travellersCount >= maxTravellers && (react_1.default.createElement(components_common_notifications_1.WarningNotification, { title: t('search:rooms.maxTravelers.title', { maxTravellers }), text: t('search:rooms.maxTravelers.warning', { maxTravellers }), testId: "maxTravellersWarning", className: "warning-notification" })),
        !childrenDOBAreValid && (react_1.default.createElement(components_common_notifications_1.WarningNotification, { title: t('search:rooms.children.invalid.heading'), text: t('search:rooms.children.invalid'), testId: "invalidChildrenDOBWarning", className: "warning-notification-children" }))));
};
function TravelersInputsSection({ isManual, inputsProps, travelRooms, }) {
    if (!isManual)
        return react_1.default.createElement(TravelersInputs_1.TravelersInputs, Object.assign({}, inputsProps));
    const { changeAdultsCount, changeChildrenCount, changeDOB, childrenDobs, } = inputsProps;
    return (react_1.default.createElement(react_1.default.Fragment, null, travelRooms.map((room, roomIndex) => (react_1.default.createElement(TravelersInputs_1.TravelersInputs, Object.assign({ key: roomIndex }, inputsProps, { changeAdultsCount: nextValue => changeAdultsCount(nextValue, roomIndex), changeChildrenCount: nextValue => changeChildrenCount(nextValue, roomIndex), changeDOB: childrenDobIndex => changeDOB(childrenDobIndex, roomIndex), adults: room.adultsAmount, childrenDobs: room.childrenIdx.map(childrenDobsIndex => 
        // Display only related to current room children dobs
        // Children calculation on BE starts with 1
        // And we increment childrenIdx (that's why '- 1')
        childrenDobs[childrenDobsIndex - 1]), isManual: true, className: `room-${roomIndex + 1}` }))))));
}
exports.default = TravelRooms;
//# sourceMappingURL=TravelRooms.js.map